import axios from '../../../api.service'

export default {
  getSizeChartById({ commit }, id) {
    return axios.get(`/wholesale/size-chart/${id}`).then((res) => {
      commit('SET_SIZE_CHART', res.data)
    })
  },
}
